import { Button, Modal, ModalBody } from "reactstrap";

// SDD 038 - Resultado da liberacao de execucao em lote. So fecha pelo botao OK
// (sem backdrop/ESC/timeout) para dar tempo de ler os motivos das falhas.
export function identificacaoOS(os) {
  if (os?.numero) return os.ano ? `OS ${os.numero}/${os.ano}` : `OS ${os.numero}`
  return `OS #${os?.id}`
}

export default function ModalResultadoLiberacao({ config, onClosed }) {
  const liberadas = config?.liberadas || []
  const falhas = config?.falhas || []

  return (
    <Modal isOpen={!!config} size="lg" backdrop="static" keyboard={false}>
      <ModalBody>
        <h2>Resultado da liberação</h2>
        <hr />
        <p>
          <strong>{liberadas.length} liberada(s), {falhas.length} com falha</strong>
        </p>
        {falhas.length > 0 && (
          <ul className="pl-3">
            {falhas.map(el => (
              <li key={el.id}>
                {identificacaoOS(el)}: {el.motivo}
              </li>
            ))}
          </ul>
        )}
        <div className="text-right mt-4">
          <Button type="button" color="primary" onClick={onClosed}>OK</Button>
        </div>
      </ModalBody>
    </Modal>
  )
}
